import React, { ReactElement } from 'react';
import { getUserProfileDetail } from 'src/constants/pages';
import {
  DiscussionCard,
  DiscussionCardHeader,
  Avatar,
  CardType,
} from '@amzn/cuminuicomponents';
import DOMPurify from 'isomorphic-dompurify';
import { QuoteState } from 'src/types/DiscussionPost';
import { KatIcon } from '@amzn/katal-react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';

export interface QuoteCardProps {
  username: string;
  userId?: string;
  avatarSrc: string;
  content?: string;
  contentJSX?: ReactElement;
  actions?: ReactElement;
  state?: QuoteState
}

const QuoteCard: React.FC<QuoteCardProps> = ({
  username,
  userId,
  avatarSrc,
  contentJSX,
  content,
  actions,
  state,
}) => {
  const { t } = useTranslation();
  const { basePath } = useRouter();
  const linkToProfile = userId && `${basePath}${getUserProfileDetail(userId)}`;
  const footer = state === QuoteState.updated && (
  <span data-testid="updated-quote-msg" className="text-kat-tarpon">
    <KatIcon name="info-circle-fill" size="xsmall" />
    <span className="ltr:ml-1 rtl:mr-1">{t('discussionCard_quoteEdited')}</span>
  </span>
  );

  const getContent = () => {
    if (state === QuoteState.deleted) {
      return (
        <span data-testid="deleted-quote-msg" className="bg-kat-seattle p-1.5 before:content-['['] after:content-[']']">
          { t('discussionCard_postDeleted')}
        </span>
      );
    }
    if (contentJSX) {
      return (
        <div
          data-testid="quote-content"
          className="discourse-forums break-words images:max-w-full"
        >
          {contentJSX}
        </div>
      );
    }
    return (
      <div
        data-testid="quote-content"
        className="discourse-forums break-words images:max-w-full"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: content ? DOMPurify.sanitize(content) : '',
        }}
      />
    );
  };
  return (
    <DiscussionCard
      cardType={CardType.quote}
      header={(
        <DiscussionCardHeader
          authoredBy={username}
          authoredByHref={linkToProfile}
          datePosted={new Date()}
          avatar={
            <Avatar size="sm" src={avatarSrc} href={linkToProfile} />
    }
          actions={actions}

        />
    )}
      content={getContent()}
      footer={footer}
    />
  );
};

QuoteCard.defaultProps = {
  userId: '',
  actions: undefined,
  state: undefined,
  content: undefined,
  contentJSX: undefined,
};
export default QuoteCard;
